import useMediaQuery from "@mui/material/useMediaQuery";
import { Theme } from "@mui/material";

const useMobileLayout = () => {
  return useMediaQuery((theme: Theme) => theme.breakpoints.down("lg"));
};

export default useMobileLayout;
